import FilterPanel from "./FilterPanel";
import Share from "./Share";
import ajax from "./helpers/ajax";
import { addNotification } from "./helpers/notifications";
import { getErrorMessage } from "./helpers/errors";

const Search = {
  debug: false,
  init: () => {
    // check if current page is the search page
    Search.isSearchPage();

    Search.trace("digiteketData.currentPage: " + digiteketData.currentPage);
    Search.trace("digiteketData.maxPage: " + digiteketData.maxPage);

    // get load more btn
    const loadMoreBtn = document.querySelector(".result-load-more-trigger");

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener("click", function () {
        Search.loadMore(this);
      });

      // check if there are more pages
      Search.isLastPage(loadMoreBtn);
    }

    // update tags present
    FilterPanel.updateTagsPresent();
  },

  trace: (io) => {
    if (Search.debug) {
      console.log(io);
    }
  },

  loadMore: (btn) => {
    // disable load more btn
    if (btn) Search.disableLoadMoreBtn(btn);

    const postWrapper = document.querySelector(".result-wrapper");

    // load more posts
    ajax
      .get("digiteket_load_more_results", {
        current_page: digiteketData.currentPage,
      })
      .then((res) => {
        const data = res.data;

        if (data && data.length != -1) {
          if (postWrapper) {
            // populate pre-rendered cards to the DOM
            data.forEach((card) => {
              postWrapper.insertAdjacentHTML("beforeend", card);
            });

            // increment page nr
            digiteketData.currentPage++;

            Search.trace(
              "digiteketData.currentPage: " + digiteketData.currentPage
            );
            Search.trace("digiteketData.maxPage: " + digiteketData.maxPage);

            // check if there are more pages
            Search.isLastPage(btn);

            // activate share btns
            Share.activateBtns();

            // update tags present
            FilterPanel.updateTagsPresent();
          }
        }

        // enable load more btn
        if (btn) Search.enableLoadMoreBtn(btn);
      })
      .catch((error) => {
        // fail silently to the console
        addNotification(getErrorMessage(error), "error", true);

        // enable load more btn
        if (btn) Search.enableLoadMoreBtn(btn);
      });
  },

  enableLoadMoreBtn: (btn) => {
    btn.classList.remove("animate--pulsate");
    btn.innerText = "Visa fler!";
    btn.disabled = false;
  },

  disableLoadMoreBtn: (btn) => {
    btn.classList.add("animate--pulsate");
    btn.innerText = "Laddar...";
    btn.disabled = true;
  },

  removeLoadMoreBtn: (btn) => {
    if (btn) btn.remove();
  },

  isLastPage: (btn) => {
    if (
      digiteketData.maxPage == 0 ||
      digiteketData.currentPage == digiteketData.maxPage
    ) {
      if (btn) btn.remove();
    }
  },

  isSearchPage: () => {
    const bodyElement = document.body;

    // check if current page is the search page (we don't want to focus the search field on front page)
    if (bodyElement && bodyElement.classList.contains("search")) {
      // focus input search field
      Search.focusInputSearchField();
    }
  },

  focusInputSearchField: () => {
    const inputSearchField = document.querySelector("input[type='search']");

    if (inputSearchField) {
      if (inputSearchField.value == "") {
        inputSearchField.focus(); // only set focus if the search input is empty
      }
    }
  },
};

export default Search;
